import { render } from "./Routing.vue?vue&type=template&id=bac44510&scoped=true&lang=pug"
import script from "./Routing.vue?vue&type=script&lang=js"
export * from "./Routing.vue?vue&type=script&lang=js"

import "./Routing.vue?vue&type=style&index=0&id=bac44510&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bac44510"]])

export default __exports__